// extracted by mini-css-extract-plugin
module.exports = {"adv-banner":"index_adv-banner_3RL8n"};